// export const NumberFormat = (inputNumber) =>
//   new Intl.NumberFormat("en-IN", {
//     maximumFractionDigits: 0, 
//     useGrouping: true, 
//   }).format(Number(inputNumber));

export const NumberFormat = (inputNumber) => {
  if (inputNumber == null || isNaN(Number(inputNumber))) {
    return 0; // Default value when input is invalid
  }
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
    useGrouping: true,
  }).format(Number(inputNumber));
};